import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import { useAuth } from "../../context/AuthContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isLoading, isAuthenticated, role, getDefaultRedirectByRole } = useAuth();
  const [isDemoAccountsOpen, setIsDemoAccountsOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "marketuser1@agromart.local",
    password: "ChangeMe123!",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    try {
      const data = await login(formData);
      const nextPath = location?.state?.from || getDefaultRedirectByRole(data?.user?.role);
      const nextState = location?.state?.postLoginAction
        ? { postLoginAction: location.state.postLoginAction }
        : undefined;
      navigate(nextPath, { replace: true, state: nextState });
    } catch (error) {
      setErrorMessage(error?.message || "Unexpected error occurred.");
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      if (location?.state?.from) {
        return;
      }
      navigate(getDefaultRedirectByRole(role), { replace: true });
    }
  }, [isAuthenticated, location?.state?.from, role, navigate, getDefaultRedirectByRole]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 lg:pt-18">
        <section className="max-w-md mx-auto px-4 py-12">
          <div className="bg-surface border border-border rounded-xl shadow-elevation-2 p-6">
            <div className="mb-6 text-center">
              <div className="w-12 h-12 bg-primary-100 text-primary rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="LogIn" size={22} />
              </div>
              <h1 className="text-2xl font-semibold text-text-primary">Sign In</h1>
              <p className="text-sm text-text-secondary mt-1">
                AgroMart hesabınla giriş yap
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="password">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              {errorMessage && (
                <div className="text-sm bg-error-100 text-error rounded-md px-3 py-2">
                  {errorMessage}
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-primary text-white py-2.5 rounded-md font-medium hover:bg-primary-700 transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            <div className="mt-4 text-sm text-center text-text-secondary">
              Henüz hesabınız yok mu?{" "}
              <Link to="/signup" className="font-medium text-primary hover:text-primary-700 transition-colors">
                Üye Ol
              </Link>
            </div>

            <div className="mt-5 rounded-md border border-border bg-secondary-100 overflow-hidden">
              <button
                type="button"
                onClick={() => setIsDemoAccountsOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-3 py-3 text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
              >
                <span>Demo hesaplar:</span>
                <Icon
                  name="ChevronDown"
                  size={16}
                  className={`transition-transform duration-200 ${isDemoAccountsOpen ? "rotate-180" : ""}`}
                />
              </button>

              {isDemoAccountsOpen && (
                <div className="border-t border-border px-3 pb-3 text-xs text-text-secondary">
                  <p className="pt-3">superadmin@agromart.local / ChangeMe123!</p>
                  <p>marketuser1@agromart.local / ChangeMe123!</p>
                  <p>marketuser2@agromart.local / ChangeMe123!</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LoginPage;
